import { Box, IconButton, Snackbar, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useModal } from '@/hooks'
import { ModalType } from '@/store/app'
import { SuccessIcon } from '../../icons'

export const CertificateComplete = () => {
  const { modalOpened, hideModal } = useModal()

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    hideModal()
  }

  return (
    <Snackbar
      open={modalOpened === ModalType.MEDCOMPLEX_COMPLETE_CERTIFICATE}
      autoHideDuration={3000}
      onClose={handleClose}
      message={
        <Stack flexDirection={'row'} alignItems={'center'} gap={'12px'}>
          <SuccessIcon />
          Сертификат поверки успешно
          <br />
          добавлен
        </Stack>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      action={
        <Box>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
    />
  )
}
